(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ============================
     结构型图片 mega menu tab 切换
  ============================ */
  function initImageMegaMenu(root) {
    const menus = (root || document).querySelectorAll('.mega-menu--image-grid');

    menus.forEach((menu) => {
      const tabs = menu.querySelectorAll('.mega-menu__tab-link');
      const panels = menu.querySelectorAll('.mega-menu__panel');
      if (!tabs.length || !panels.length) return;

      const activateTab = (tab) => {
        const target = tab.getAttribute('data-tab');
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t === tab);
        });
        panels.forEach((panel) => {
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-tab') === target
          );
        });
      };

      // 初始状态：保证第一个 panel 打开
      const active = menu.querySelector('.mega-menu__tab-link.is-active') || tabs[0];
      if (active) activateTab(active);
    });
  }

  // 首次加载
  document.addEventListener('DOMContentLoaded', () => {
    initImageMegaMenu(document);
  });

  // Shopify 主题编辑器里 section 重载时也初始化
  document.addEventListener('shopify:section:load', (event) => {
    initImageMegaMenu(event.target);
  });

  // 事件委托：点击 / hover 左侧 tab
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.mega-menu__tab-link');
    if (!tab) return;
    const menu = tab.closest('.mega-menu--image-grid');
    if (!menu) return;

    const tabs = menu.querySelectorAll('.mega-menu__tab-link');
    const panels = menu.querySelectorAll('.mega-menu__panel');
    const target = tab.getAttribute('data-tab');

    tabs.forEach((t) => {
      t.classList.toggle('is-active', t === tab);
    });
    panels.forEach((panel) => {
      panel.classList.toggle(
        'is-active',
        panel.getAttribute('data-tab') === target
      );
    });
  });

  document.addEventListener('mouseenter', (event) => {
    const tab = event.target.closest('.mega-menu__tab-link');
    if (!tab) return;
    const menu = tab.closest('.mega-menu--image-grid');
    if (!menu) return;

    const tabs = menu.querySelectorAll('.mega-menu__tab-link');
    const panels = menu.querySelectorAll('.mega-menu__panel');
    const target = tab.getAttribute('data-tab');

    tabs.forEach((t) => {
      t.classList.toggle('is-active', t === tab);
    });
    panels.forEach((panel) => {
      panel.classList.toggle(
        'is-active',
        panel.getAttribute('data-tab') === target
      );
    });
  }, true);


  } catch(e) { console.error(e); }
})();
})();
